import { render } from "./BlockLoader.vue?vue&type=template&id=e1fccaec&scoped=true"
import script from "./BlockLoader.vue?vue&type=script&lang=js"
export * from "./BlockLoader.vue?vue&type=script&lang=js"

import "./BlockLoader.vue?vue&type=style&index=0&id=e1fccaec&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1fccaec"]])

export default __exports__